import GiftBlock from "./GiftBlock";

export default GiftBlock;
